import { loadReportCharts, printReport } from '@/api/reports'
import { _ } from 'vue-underscore'
import { zerosFormatter, allQuarters, separadorMiles, filterOutliers } from '@/utils/chartutils'
import i18n from '@/i18n'
import { build_basicbar } from '@/utils/chartutils'

const state = () => {
  return {
    selectedReportsOptions: [],
    reportZoom: 13,
    reportsCharts: [],
    mapSourceDetails: [],
    unemployment_contracts_over_active_pop_evo: {
      title: { text: i18n.t('unemployment-contracts-over-actv-pop') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      yAxis: [{
        type: 'linear',
        title: {
          text: null
        },
        labels: {
          formatter: function() { return zerosFormatter(this.value) }
        }
      }],
      series: [],
      tooltip: {
        pointFormat: ' {series.name}: <b>{point.y}</b><br/>',
        shared: true
      },
      legend: {
        enabled: true
      }
    },
    unemployment_contracts_yoy_evo: {
      title: { text: i18n.t('unemployment-contracts-yoy') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      yAxis: [{
        type: 'linear',
        title: {
          text: null
        },
        labels: {
          formatter: function() { return zerosFormatter(this.value) }
        }
      }],
      series: [],
      tooltip: {
        pointFormat: ' {series.name}: <b>{point.y}</b><br/>',
        shared: true
      },
      legend: {
        enabled: true
      }
    },
    marketevolution_trans: {
      title: { text: i18n.t('chartsData.market-evol') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
        }
      }],
      xAxis: {},
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      series: []
    },
    timetosaleevolution: {
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      chart: {
        height: 300
      },
      title: { text: i18n.t('dataSelectors.published-time') },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('assetData.months') : '') }
        }
      }],
      xAxis: {},
      series: []
    },
    marketevolution_all: {
      title: { text: i18n.t('chartsData.market-evol') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
        }
      }],
      xAxis: {},
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      series: []
    },
    askingnewold: {
      plotOptions: {
        series: {
          connectNulls: false
        }
      },
      chart: {
        height: 300
      },
      title: { text: i18n.t('chartsData.asking-by-pub-date') },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
        }
      }],
      series: []
    },
    builtstockyears: {
      title: { text: i18n.t('chartsData.build-stock-year-100') },
      credits: {
        enabled: false
      },
      chart: {
        height: 300
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('uts') : '') }
        }
      }],
      series: [],
      legend: {
        enabled: false
      }
    },
    newconstructionsnumberevo: {
      title: { text: '# ' + i18n.t('chartsData.started-dwel') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('uts') : '') }
        }
      }],
      series: [],
      legend: {
        enabled: false
      }
    },
    askingpriceevolutionchart: {
      title: { text: i18n.t('chartsData.asking-price-evol') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
        }
      }],
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      series: []
    },
    timeToRentchart: {
      title: { text: i18n.t('dataSelectors.published-time') },
      chart: {
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true
      },
      yAxis: [{
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('assetData.months') : '') }
        }
      }],
      plotOptions: {
        series: {
          connectNulls: true
        }
      },
      series: []
    }
  }
}

const getters = {
  selectedReportsOptions: (state) => state.selectedReportsOptions,
  reportZoom: (state) => state.reportZoom,
  mapSourceDetails: (state) => state.mapSourceDetails
}

const mutations = {
  // new
  SET_SELECTED_REPORTS_OPTIONS: (state, reportsOptions) => {
    state.selectedReportsOptions = reportsOptions
  },
  SET_REPORT_ZOOM: (state, reportZoom) => {
    state.reportZoom = reportZoom
  },
  SET_MAP_SOURCE_DETAILS: (state, mapSourceDetails) => {
    state.mapSourceDetails = mapSourceDetails
  },
  SET_REPORTS_CHARTS: (state, content) => {
    const contentbykey = state.reportsCharts.filter(item => item.key !== content.key)
    contentbykey.push(content)
    state.reportsCharts = contentbykey
  },
  CLEAR_REPORTS_CHARTS: (state, content) => {
    const contentbykey = state.reportsCharts.filter(item => item.key !== content.key)
    state.reportsCharts = contentbykey
  }
}

const actions = {
  setSelectedReportsOptions({ commit }, selectedReportsOptions) {
    commit('SET_SELECTED_REPORTS_OPTIONS', selectedReportsOptions.value)
  },
  setReportZoom({ commit }, reportZoom) {
    commit('SET_REPORT_ZOOM', reportZoom.value)
  },
  setMapSourceDetails({ commit }, mapSourceDetails) {
    commit('SET_MAP_SOURCE_DETAILS', mapSourceDetails)
  },
  loadReportCharts({ commit, state }, filter) {
    return new Promise((resolve, reject) => {
      loadReportCharts(filter).then(responsed => {
        const response = responsed.data
        commit('SET_MAP_SOURCE_DETAILS', response.map_source_details)
        const actualstore = state

        state.selectedReportsOptions.forEach(report => {
          switch (report.id) {
            case 'unemployment':
              report.charts = []
              report.charts.push(DoubleBarChartUnemploymentContracts(actualstore['unemployment_contracts_over_active_pop_evo'], response.unemployment_charts_data, 'percentage'))
              report.charts.push(DoubleBarChartUnemploymentContracts(actualstore['unemployment_contracts_yoy_evo'], response.unemployment_charts_data, 'yoy'))
              break
            case 'sales_price':
            case 'liquidity':
              report.charts = []

              var askingvalues = response.saleevolution_charts_data.askings.map((item) => {
                return {
                  name: item.label,
                  y: item.em2
                }
              })

              var transactionvalues = response.saleevolution_charts_data.transactions.map((item) => {
                return {
                  name: item.label,
                  y: item.em2
                }
              })

              var fomentovalues = response.saleevolution_charts_data.fomento.map((item) => {
                return {
                  name: item.label,
                  y: item.em2
                }
              })

              var appraisalpub = response.saleevolution_charts_data.fomento.map((item) => {
                return {
                  name: item.label,
                  y: item.pub
                }
              })

              var tts = response.saleevolution_charts_data.timeToSale.map((item) => {
                return {
                  name: item.label,
                  y: item.em2
                }
              })

              var ttsON = response.saleevolution_charts_data.timeToSale.map((item) => {
                return {
                  name: item.label,
                  y: item.em2ON
                }
              })

              var tts2H = response.saleevolution_charts_data.timeToSale.map((item) => {
                return {
                  name: item.label,
                  y: item.em22H
                }
              })

              if (report.id === 'liquidity') {
                report.charts.push(TimeToSaleGraph(actualstore['timetosaleevolution'], tts, ttsON, tts2H))
                report.charts.push(MarketEvolutionGraph(actualstore['marketevolution_trans'], askingvalues, transactionvalues, fomentovalues, appraisalpub, false, filter.country_name))
              }
              if (report.id === 'sales_price') {
                report.charts.push(MarketEvolutionGraph(actualstore['marketevolution_all'], askingvalues, transactionvalues, fomentovalues, appraisalpub, true, filter.country_name))
                report.charts.push(AskingNewOldGraph(actualstore['askingnewold'], response.saleevolution_charts_data.askingEvolution, askingvalues))
              }

              break
            case 'new_dev':
              report.charts = []
              var builtstock = response.saleevolution_charts_data.builtStockYears.map((item) => {
                return {
                  name: item.label,
                  y: item.pub
                }
              })

              report.charts.push(BuiltStockGraph(actualstore['builtstockyears'], builtstock))
              report.charts.push(SimpleChart(actualstore['newconstructionsnumberevo'], response.new_dev_charts_data['constructions']))
              break
            case 'rental_prices':
              report.charts = []

              report.charts.push(SimpleLineChart(actualstore['askingpriceevolutionchart'], response.rental_prices_charts_data.askings))
              report.charts.push(SimpleDoubleLineChart(actualstore['timeToRentchart'], response.rental_prices_charts_data.timeToRent))
              break
            case 'sale_top25municipalities':
              report.charts = []

              report.charts.push(build_basicbar('askingpricetop25', null, 'em2_Asking', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              report.charts.push(build_basicbar('top25growthasking', null, 'asking_Growth_Var_YoY_Em2', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              report.charts.push(build_basicbar('timetosaletop25', null, 'avg_Time_To_Sale', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              break
            case 'rent_top25municipalities':
              report.charts = []

              report.charts.push(build_basicbar('askingtop25rent', null, 'em2_month_asking_rent', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              report.charts.push(build_basicbar('top25growthaskingrent', null, 'asking_rent_var_YoY_Em2_month', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              report.charts.push(build_basicbar('timetosaletop25munrent', null, 'avg_Time_To_Rent', response.top25memberbench, filter.country_name, filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level })[0].name, 'asking', filter.allgeolevels.filter((item) => { return item.level === filter.geolevel.level }), false))
              break
            default:
              break
          }
        })

        state.reportsCharts.key = 'reports'

        resolve(true)
      }).catch(error => {
        // debugger
        reject(error)
      })
    })
  },
  clearReportsCharts({ commit, state }, filter) {
    commit('CLEAR_REPORTS_CHARTS', filter)
    return new Promise((resolve, reject) => {
      resolve()
    })
  },
  printReport({ commit, state }, filter) {
    return new Promise((resolve, reject) => {
      printReport(filter).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

function DoubleBarChartUnemploymentContracts(chartObj, objdata, filtro) {
  // Obtengo los labels del primer elemento (los años de las X)
  var alllabels = objdata.map((item) => { return item.label })

  // Añado los labels al eje x

  var data_line_one = []
  var name_line_one = ''
  var data_line_two = []
  var name_line_two = ''

  if (filtro === 'yoy') {
    objdata = objdata.filter(item => { return item.yoy_unemp !== null })

    data_line_one = objdata.map((item) => { return { value: item.yoy_unemp, label: item.label } })
    name_line_one = i18n.t('yoy-unemployment')
    data_line_two = objdata.map((item) => { return { value: item.yoy_contracts, label: item.label } })
    name_line_two = i18n.t('yoy-contracts')
  } else {
    data_line_one = objdata.map((item) => { return { value: item.percentage_unemp_over_activepop, label: item.label } })
    name_line_one = i18n.t('percent-unemployment-over-actv-pop')
    data_line_two = objdata.map((item) => { return { value: item.percentage_contracts_over_activepop, label: item.label } })
    name_line_two = i18n.t('percent-contracts-over-actv-pop')
  }

  chartObj.xAxis = {
    type: 'category',
    categories: alllabels
  }

  // Empiezo a crear las series
  const allseries = []
  if (data_line_one.length > 0) {
    // Datos de las barras
    allseries.push({
      data: _.map(data_line_one, function(item) {
        return {
          'name': item.label,
          'y': item.value,
          'color': '#004753'
        }
      }),
      name: name_line_one,
      type: 'spline',
      color: '#004753',
      yAxis: 0
    })
  }

  if (data_line_two.length > 0) {
    chartObj.yAxis.push({
      type: 'linear',
      opposite: true,
      title: {
        text: ''
      },
      labels: {
        formatter: function() { return this.value }
      }
    })

    allseries.push({
      type: 'spline',
      color: 'rgb(215, 174, 70)',
      name: name_line_two,
      yAxis: 1,
      data: _.map(data_line_two, function(item) {
        return {
          'name': item.label,
          'y': item.value,
          'color': '#1e3cff'
        }
      })
    })
  }

  chartObj.series = allseries
  return chartObj
}

function TimeToSaleGraph(actualstore, tts, ttsON, tts2H) {
  tts = tts.filter(item => item.y !== null)
  ttsON = ttsON.filter(item => item.y !== null)
  tts2H = tts2H.filter(item => item.y !== null)
  let alllabels = tts
  alllabels = allQuarters(alllabels.map((item) => { return item.name }))

  actualstore.xAxis = {
    type: 'category',
    categories: alllabels
  }

  const allseries = []
  if (tts.length > 0) {
    allseries.push({
      yAxis: 0,
      zIndex: 4,
      name: i18n.t('dataSelectors.all'),
      visible: false,
      data: tts,
      type: 'spline',
      marker: {
        enabled: tts.length === 1
      },
      color: '#e7cd90',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
        shared: true
      }
    })
  }

  if (ttsON.length > 0) {
    allseries.push({
      yAxis: 0,
      zIndex: 4,
      name: i18n.t('new-dev'),
      data: ttsON,
      type: 'spline',
      marker: {
        enabled: ttsON.length === 1
      },
      color: '#9d7520',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
        shared: true
      }
    })
  }

  if (tts2H.length > 0) {
    allseries.push({
      yAxis: 0,
      zIndex: 4,
      name: i18n.t('chartsData.2nd-hand'),
      data: tts2H,
      type: 'spline',
      marker: {
        enabled: tts2H.length === 1
      },
      color: '#00b1ff',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
        shared: true
      }
    })
  }

  actualstore.series = allseries
  return actualstore
}

function MarketEvolutionGraph(actualstore, askingvalues, transactionvalues, fomentovalues, appraisalpub, all, country_name) {
  let alllabels = askingvalues.concat(transactionvalues).concat(fomentovalues)
  alllabels = allQuarters(alllabels.map((item) => { return item.name }))

  actualstore.xAxis = {
    type: 'category',
    categories: alllabels
  }

  const allseries = []
  if (all) {
    if (askingvalues.length > 0) {
      allseries.push({
        yAxis: 0,
        zIndex: 4,
        name: i18n.t('dataSelectors.asking-sqm'),
        data: askingvalues,
        type: 'spline',
        marker: {
          enabled: askingvalues.length === 1
        },
        color: '#28cf64 ',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
          shared: true
        }
      })
    }

    if (transactionvalues.length > 0) {
      var name = i18n.t('dataSelectors.transactions')
      if (country_name === 'Italia') {
        name = 'OMI'
      }
      allseries.push({
        yAxis: 0,
        zIndex: 3,
        name: name + ' (' + i18n.t('marketplace.eur-sqm') + ')',
        data: transactionvalues,
        type: 'spline',
        marker: {
          enabled: transactionvalues.length === 1
        },
        color: '#00b1ff',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
          shared: true
        }
      })
    }

    fomentovalues = fomentovalues.filter((item) => { if (item.y !== 0) { return item } })
    if (fomentovalues.length > 0 && country_name !== 'Italia' && country_name !== 'Grecia') {
      allseries.push({
        yAxis: 0,
        zIndex: 2,
        name: i18n.t('assetData.appraisals') + ' (' + i18n.t('marketplace.eur-sqm') + ')',
        data: fomentovalues,
        type: 'spline',
        marker: {
          enabled: fomentovalues.length === 1
        },
        color: '#9d7520',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
          shared: true
        }
      })
    }

    if (actualstore.yAxis.length === 1) {
      actualstore.yAxis.push({
        min: 0,
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' uts' : '') }
        },
        opposite: true
      })
    }

    appraisalpub = appraisalpub.filter(item => {
      return item.y !== 0 && item.y !== null
    })

    if (appraisalpub.length > 0) {
      allseries.push({
        name: i18n.t('dataSelectors.transactions') + ' (#)',
        yAxis: 1,
        zIndex: 1,
        data: appraisalpub,
        type: 'column',
        marker: {
          enabled: appraisalpub.length === 1
        },
        color: '#1e3cff',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
          shared: true
        }
      })
    }
  } else {
    appraisalpub = appraisalpub.filter(item => {
      return item.y !== 0 && item.y !== null
    })

    if (appraisalpub.length > 0) {
      allseries.push({
        name: i18n.t('dataSelectors.transactions') + ' (#)',
        data: appraisalpub,
        type: 'column',
        marker: {
          enabled: appraisalpub.length === 1
        },
        color: '#1e3cff',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
          shared: true
        }
      })
    }
  }

  actualstore.series = allseries
  return actualstore
}

function AskingNewOldGraph(actualstore, askingevolution, askingvalues) {
  let alllabels = askingvalues.concat(askingevolution)
  alllabels = allQuarters(alllabels.map((item) => { return item.name }))

  var askingnew = askingevolution.map((item) => {
    return {
      name: item.label,
      y: item.em2new,
      muestra: item.pubnew
    }
  })

  var formated_askingevolution = filterOutliers(askingevolution.map(item => { return item.em2old }))
  askingevolution = askingevolution.filter(item => {
    var value_return = ''
    formated_askingevolution.forEach(item_f => {
      if (item_f === item.em2old) {
        value_return = item
      }
    })
    if (value_return !== '') {
      return value_return
    }
  })

  var askingold = askingevolution.map((item) => {
    return {
      name: item.label,
      y: item.em2old === 0 ? null : item.em2old,
      muestra: item.pubold
    }
  })

  actualstore.xAxis = {
    type: 'category',
    categories: alllabels
  }

  const allseries = []

  if (askingnew.length > 0) {
    askingnew = askingnew.filter(item => { return item.muestra >= 10 })
    allseries.push({
      yAxis: 0,
      zIndex: 3,
      name: i18n.t('chartsData.eur-sqm-new-pub'),
      data: askingnew,
      type: 'spline',
      marker: {
        enabled: askingnew.length === 1
      },
      color: '#7c5a1a',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
        shared: true
      }
    })
  }

  if (askingold.length > 0) {
    askingold = askingold.filter(item => { return item.muestra >= 10 })
    allseries.push({
      yAxis: 0,
      zIndex: 2,
      name: i18n.t('chartsData.eur-sqm-old-pub'),
      data: askingold,
      type: 'spline',
      marker: {
        enabled: askingold.length === 1
      },
      color: '#9d7520',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
        shared: true
      }
    })
  }

  actualstore.series = allseries
  return actualstore
}

function BuiltStockGraph(actualstore, builtstock) {
  const alllabels = builtstock.map((item) => { return item.name })

  actualstore.xAxis = {
    type: 'category',
    categories: alllabels
  }
  const allseries = []
  if (builtstock.length > 0) {
    allseries.push({
      data: builtstock,
      name: i18n.t('uts'),
      type: 'column',
      color: '#1e3cff',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
        shared: true
      }
    })
  }

  actualstore.series = allseries
  return actualstore
}

function SimpleChart(chartObj, objdata) {
  const alllabels = objdata.map((item) => { return item.name })

  chartObj.xAxis = {
    type: 'category',
    categories: alllabels
  }
  const allseries = []
  if (objdata.length > 0) {
    allseries.push({
      data: objdata,
      name: i18n.t('uts'),
      type: 'column',
      color: '#1e3cff',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.0f}</b><br/>',
        shared: true
      }
    })
  }

  chartObj.series = allseries
  return chartObj
}

function SimpleLineChart(chartObj, objdata) {
  if (objdata.length > 0) {
    let alllabels = objdata.map((item) => { return item.label })
    alllabels = allQuarters(alllabels)

    chartObj.xAxis = {
      type: 'category',
      categories: alllabels
    }

    const allseries = []
    allseries.push({
      yAxis: 0,
      zIndex: 2,
      name: i18n.t('dataSelectors.asking-sqm'),
      data: objdata.map((item) => {
        return {
          name: item.label,
          y: item.em2
        }
      }),
      type: 'spline',
      marker: {
        enabled: objdata.length === 1
      },
      color: '#28cf64 ',
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
        shared: true
      }
    })

    chartObj.series = allseries
    return chartObj
  }
}

function SimpleDoubleLineChart(chartObj, objdata) {
  objdata = objdata.filter(item => item.em2 !== null)
  if (objdata.length > 0) {
    let alllabels = objdata.map((item) => { return item.label })
    alllabels = allQuarters(alllabels)

    chartObj.xAxis = {
      type: 'category',
      categories: alllabels
    }

    const ttsON = objdata.map((item) => {
      return {
        name: item.label,
        y: item.em2ON
      }
    })

    const tts2H = objdata.map((item) => {
      return {
        name: item.label,
        y: item.em22H
      }
    })

    const allseries = []

    if (ttsON.length > 0) {
      allseries.push({
        yAxis: 0,
        zIndex: 4,
        name: i18n.t('new-dev'),
        data: ttsON,
        type: 'spline',
        marker: {
          enabled: ttsON.length === 1
        },
        color: '#9d7520',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
          shared: true
        }
      })
    }

    if (tts2H.length > 0) {
      allseries.push({
        yAxis: 0,
        zIndex: 4,
        name: i18n.t('chartsData.2nd-hand'),
        data: tts2H,
        type: 'spline',
        marker: {
          enabled: tts2H.length === 1
        },
        color: '#00b1ff',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:,.1f}</b><br/>',
          shared: true
        }
      })
    }

    chartObj.series = allseries
    return chartObj
  }
}
